import { connect } from "react-redux";
import CaseView from "./View";
import { bindActionCreators } from "redux";
import {
    caseByIdRequest,
    caseStatusUpdateRequest,
    loanAccountRequest,
    loanApplicationByIdRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    caseByIdResponse : state.CarLoan.caseByIdResponse,
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
    loanApplicationByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    loanAccountResponse : state.CarLoan.loanAccountResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseByIdRequest,
        caseStatusUpdateRequest,
        loanApplicationByIdRequest,
        loanAccountRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CaseView);